<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'bg-surface-secondary',
  },
})

definePageMeta({
  name: 'literature-index',
  layout: 'default',
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: {
    label: 'Faglitteratur',
  },
  title: 'Faglitteratur',
})

useSeoMeta({
  title: 'Faglitteratur',
  description: 'Finn faglitteratur',
})

const route = useRoute<'literature-index'>()

const { sortedFilteredLiterature, showOnlyFavorites, isLoading, suspense } = useLiteratureFilters()

if (import.meta.server) {
  await suspense()
}

const { toggleFavorite } = useFavorites()

useTrackLastActivity(() => String(route.meta.title))
</script>

<template>
  <NuxtLayout name="overview-with-bread-crumbs-and-title" page-title="Faglitteratur" sticky-panel-top>
    <template #background-illustration>
      <IllustrationFaglitteratur class="-translate-y-[4%]" />
    </template>

    <div class="w-full flex items-start gap-l">
      <StickyContent class="hidden xl:flex flex-col shrink-0 max-h-[calc(100dvh-6.5rem)] no-scrollbar overflow-y-auto [--padding-top:0rem]">
        <LiteratureFilterSidebar />
      </StickyContent>

      <h2 class="sr-only">Faglitteratur</h2>

      <div class="flex-1 min-w-0 flex flex-col gap-2xs">
        <StickyContent class="bg-white z-10 pt-m pb-3xs">
          <LiteratureListHeader />
        </StickyContent>
        <LiteratureList :literature="sortedFilteredLiterature" :is-favorite="showOnlyFavorites" :toggle-favorite="toggleFavorite" :is-loading="isLoading" />
      </div>
    </div>
  </NuxtLayout>
</template>
